import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-stone-50 py-16 md:py-24" data-id="element-55" data-mp="15capavgsvj0g">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-56" data-mp="1jd4znjneru1r">
        {showUrgency && <CountdownPanel headline="L’offerta di lancio termina tra:" subtext={`Oggi: ${offer.price}\u00A0${offer.currency} con 3 Bonus inclusi. Prezzo abituale: ${offer.listPrice}.`} data-id="element-57" data-mp="1ee1w63n2tvvw" />}

        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-58" data-mp="1o3lffaepbrra">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-59" data-mp="1o67nrc9f2bak">
            La tua iniziativa Ottobre Rosa non deve iniziare davanti a una pagina bianca
          </h2>

          <p className="mt-6 text-lg leading-relaxed text-neutral-500 md:text-xl" data-id="element-60" data-mp="n5ujjv79jbdl">
            Puoi passare ore a cercare idee, creare materiali e chiederti come organizzare ogni
            momento. Oppure puoi partire da un kit già strutturato.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-neutral-500 md:text-xl" data-id="element-61" data-mp="x2h2geg13scz">
            50 Carte di Riflessione. 150 Segnalibri Ispirazionali. Una Guida Pratica alle Attività
            di 50 pagine. E 3 Bonus per aiutarti a preparare e gestire la tua iniziativa con più
            semplicità.{' '}
            <span className="font-extrabold text-neutral-800" data-id="element-62" data-mp="1b1gsnqj6wfb9">
              Tutto è già pronto. Devi solo adattarlo al tuo gruppo.
            </span>
          </p>

          <div className="mx-auto mt-9 w-fit rounded-2xl bg-white px-8 py-6 shadow-sm ring-1 ring-neutral-200" data-id="element-63" data-mp="1ksbi13rqfv0x">
            <p className="text-4xl font-extrabold leading-none tracking-tight text-pink-900 md:text-5xl" data-id="element-64" data-mp="1pu0riezb40mw">
              {`Oggi: ${offer.price}\u00A0${offer.currency}`}
            </p>
            <p className="mt-3 text-neutral-500" data-id="element-65" data-mp="3qvqirsxrayku">
              Prezzo abituale: <span className="line-through" data-id="element-66" data-mp="3lvufxx0spd6v">{offer.listPrice}</span>
            </p>
          </div>

          <div className="mt-10" data-id="element-67" data-mp="3hcv1m7ejl4l">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-68" data-mp="3iehsnxs5w25">
              {offer.cta}
            </CtaButton>
          </div>

          <TrustIcons className="mt-8" data-id="element-69" data-mp="3uufulh35c82d" />
        </div>
      </div>
    </section>;
}